import React from 'react';
import { Request } from '../../services/requestsService';
import { formatDateTime } from '../../utils/dateUtils';

interface TaskInfoSectionProps {
  task: Request;
}

const TaskInfoSection: React.FC<TaskInfoSectionProps> = ({ task }) => {
  return (
    <div className="task-detail-section">
      <h2>Информация о задаче</h2>
      <div className="task-detail-grid">
        {task.aircraftParts && task.aircraftParts.length > 0 ? (
          <div className="task-detail-item">
            <span className="task-detail-label">Части самолета:</span>
            <div className="task-detail-value">
              <ul className="aircraft-parts-list">
                {task.aircraftParts.map((part, index) => (
                  <li key={index}>
                    {part.aircraftPartName}
                    {part.description && <span className="part-description"> - {part.description}</span>}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ) : (
          <div className="task-detail-item">
            <span className="task-detail-label">Части самолета:</span>
            <span className="task-detail-value">Не указаны</span>
          </div>
        )}
        <div className="task-detail-item">
          <span className="task-detail-label">Создано:</span>
          <span className="task-detail-value">{formatDateTime(task.createdAt)}</span>
        </div>
        <div className="task-detail-item">
          <span className="task-detail-label">Создатель:</span>
          <span className="task-detail-value">
            {task.creator?.name} {task.creator?.surname}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TaskInfoSection; 